import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EffectsModule} from "@ngrx/effects";
import {StoreModule} from "@ngrx/store";
import {PermissionEffect} from "./store/permission.effects";
import {permissionsReducer} from "./store/permission.reducer";
import {permissionsConfigKey} from "./store/permissions.config";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
      StoreModule.forFeature(permissionsConfigKey,permissionsReducer),
      EffectsModule.forFeature(PermissionEffect)
  ]
})
export class PermissionsModule { }
